<template>
  <section>
    <div class="container" style="display: flex; justify-content: center; align-items: center;">
      <div id="invoice-POS" style="font-family: Helvetica, sans-serif;">
        <h2 style="text-align: center;"><b>{{ this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.name }}</b></h2>
        <h3 style="line-height: 0.2; text-align: center; font-weight: 500;">{{this.selectedTableOrder.branchesByBranchId.areasByAreaId.name}}</h3>
        <h4 style="line-height: 0.2; text-align: center; font-weight: 500;">Contact # {{ this.selectedTableOrder.branchesByBranchId.phone1 }}</h4>
        <h5 style="line-height: 0.2; text-align: center; font-weight: 500;">NTN # {{ this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.ntn }}</h5>

        <center>
          <div style="padding: 7px; border-spacing: 0px; width: 309px; border: 2px solid #000000; border-radius: 11px;">
            <table style="border-spacing: 0; width: 100%;">
              <tbody>
              <tr style="display: flex; justify-content: space-between; align-items: center;">
                <td><small style="margin-left: 5px"><b>{{this.$moment.parseZone(String(new Date())).local().format('DD-MM-YYYY')}}</b></small></td>
                <td><small style="margin-left: 5px"><b>{{this.$moment.parseZone(String(new Date())).local().format('hh:mm:ss A')}}</b></small></td>
                <td><small style="margin-left: 5px"><b>Cashier:</b> {{ this.selectedTableOrder.usersByUserId.fullName && this.selectedTableOrder.usersByUserId.fullName.substring(0, 12) }}</small></td>
              </tr>
              <tr style="display: flex; justify-content: space-between; align-items: center;">
                <td><small style="margin-left: 5px"><b>{{ selectedTableOrder.waiter ? 'Table' : 'Customer' }}:</b> {{selectedTableOrder.table && this.selectedTableOrder.table.name}}</small></td>
                <td><small style="margin-left: 5px"><b>Waiter:</b> {{selectedTableOrder.waiter ? selectedTableOrder.waiter.name : 'N/A'}}</small></td>
              </tr>
              </tbody>
            </table>
          </div>
        </center>

        <center v-if="this.selectedTableOrder.id>0">
          <div style="padding: 7px; border-spacing: 0px; width: 309px; border: 2px solid #000000; border-radius: 11px; margin-top: 3px">
            <table style="border-spacing: 0; width: 100%;">
              <tbody>
              <tr style="display: flex; justify-content: space-between;  align-items: center;">
                <td><small style="margin-left: 5px"><b>Order #: </b></small></td>
                <td><small style="margin-left: 5px"><b>{{ this.selectedTableOrder.id>0 ? this.selectedTableOrder.id : '' }} </b></small></td>
              </tr>
              </tbody>
            </table>
          </div>
        </center>

        <center><h2>{{this.selectedTableOrder.orderTypesByOrderTypeId.type}}</h2></center>

        <center>
        <div style="padding: 7px; border-spacing: 0px; width: 309px; border: 2px solid #000000; border-radius: 11px; margin-top: 15px;">
          <table style="border-spacing: 0; width: 100%">
            <thead style="font-size:16px; padding: 11px;">
            <tr>
              <th style="width: 56%;text-align:left;"><small style="margin-left: 5px">Description</small></th>
              <th style="width: 15%;text-align:left;"><small style="margin-left: 5px">Rate</small></th>
              <th style="width: 15%;text-align:left;"><small style="margin-left: 5px">Qty</small></th>
              <th style="width: 15%;text-align:center;">Amount</th>
            </tr>
            </thead>
          </table>
        </div>
      </center>

        <center>
        <div style="padding: 7px; border-spacing: 0px; width: 309px; border: 2px solid #000000; border-radius: 11px; margin-top: 3px;">
          <table style="border-spacing: 0; width: 100%">
            <tbody>
            <template v-for="(orderItem, orderItemIndex) in this.selectedTableOrder.orderItemsById">
            <tr :key="orderItemIndex">
              <td style="width:50%;text-align:left; font-size:16px;"><small style="margin-left: 5px">{{ orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name }}</small></td>
              <td style="width:15%;text-align:center; font-size:16px;"><small style="margin-left: 5px">{{ orderItem.menuItemTypesByMenuItemTypeId.price | formatNumber }}</small></td>
              <td style="width:15%;text-align:center;font-size:16px;"><small>{{ orderItem.quantity }}</small></td>
              <td style="width:15%;text-align:center;font-size:16px;"><small>{{ orderItem.totalPrice | formatNumber }}</small></td>
            </tr>
              <template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
                <tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
                  <td style="width:50%;text-align:left; font-size:15px;"><small style="margin-left: 5px"> &nbsp;*{{itemAddOn.addOnItemsByAddOnItemId.name }}</small></td>
                  <td style="width:15%;text-align:center; font-size:15px;"><small style="margin-left: 5px">{{ itemAddOn.addOnItemsByAddOnItemId.price | formatNumber }}</small></td>
                  <td style="width:15%;text-align:center;font-size:15px;"><small>{{ itemAddOn.quantity }}</small></td>
                  <td style="width:15%;text-align:center;font-size:15px;"><small>{{ itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price | formatNumber }}</small></td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </center>

        <center>
              <div style="padding: 7px; border-spacing: 0px; width: 309px; border: 2px solid #000000; border-radius: 11px; margin-top: 3px;">
                <table style="border-spacing: 0; width: 100%;">
                  <tbody>
                  <tr style="display: flex; justify-content: space-between; align-items: center">
                    <td style="font-size:16px;">Sub Total:</td>
                    <td style="font-size:16px;"><b>Rs.{{ formatPrice(parseFloat(this.selectedTableOrder.totalPriceWithAddon).toFixed(2)) }}</b></td>
                    <td style="font-size:16px;">Tax@{{(this.selectedTableOrder.paymentMethod.id===1)? this.selectedTableOrder.branchesByBranchId.tax: this.selectedTableOrder.branchesByBranchId.cardTax}}%:</td>
                    <td style="font-size:16px;"><b>Rs.{{ formatPrice(parseFloat(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.totalPriceWithAddon).toFixed(2)) }}</b></td>
                  </tr>
                  <tr style="display: flex; justify-content: space-between; align-items: center">
                    <td style="font-size:16px;" v-if="this.selectedTableOrder.discount>0">Total Discount:</td>
                    <td style="font-size:16px;"  v-if="this.selectedTableOrder.discount>0"><b>Rs.{{ formatPrice(parseFloat(this.selectedTableOrder.discount).toFixed(2)) }}</b></td>
                  </tr>
                  <tr style="display: flex; justify-content: space-between; align-items: center;" v-if="this.selectedTableOrder.paymentMethod.id===1 && this.selectedTableOrder.cashTaken > 0">
                    <td style="font-size:16px;">Paid Amt:</td>
                    <td style="font-size:16px;"><b>Rs.{{ formatPrice(this.selectedTableOrder.cashTaken) }}</b></td>
                    <td style="font-size:16px;">Change Due:</td>
                    <td style="font-size:16px;"><b>Rs.{{ formatPrice(this.selectedTableOrder.cashGiven) }}</b></td>
                  </tr>
                  <tr style="display: flex; justify-content: space-between; align-items: center;">
                    <td style="font-size:17px; font-weight: bold;">Grand Total:</td>
                    <td style="font-size:17px; font-weight: bold;"><b>Rs.{{formatPrice(this.selectedTableOrder.billedPrice)}}</b></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </center>

        <center style="margin-top: 16px">
		<b>Thank You for visiting {{this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.name}}</b>
		<p style="font-size:10px;">
			To Place Your Order or To Give FeedBack, Call Us At {{this.selectedTableOrder.branchesByBranchId.phone1}}
			or Visit Our Restaurant
		</p>
	</center>

      </div>
    </div>
  </section>
</template>

<script>
import numeral from 'numeral';
export default {
    name:"posReceipt",
	props:['selectedTable', 'selectedTableOrder','orderCreatedtime'],
	data(){
		return{

		}
	},
	methods: {
		formatPrice(value) {
			if(value !== null){
				return numeral(value).format('0,0[.]00'); //[00] to format to two decimal number
			}
		},
	}

}
</script>

<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
}
</style>